import './Pot.styles.css';

import { Chip } from 'primereact/chip';
import { FC, useMemo } from 'react';

import commonStore from '../../../store/CommonStore';
import { formatNumber } from '../table.render.utils';
import { PotProps } from './Pot.types';

const Pot: FC<PotProps> = ({ value }) => {
  const potContent = useMemo(
    () => (
      <>
        <p className="d-inline m-0 me-2">Pot:</p>
        <b>
          {`${formatNumber(value)}`}
          {commonStore.getIsChipsConvertedToBlinds() && (
            <span className="bb-text">{' BB'}</span>
          )}
        </b>
      </>
    ),
    [value, commonStore.getIsChipsConvertedToBlinds()],
  );

  return (
    <div className="pot-wrapper" data-ignore-outside-click={true}>
      <Chip className="chip" template={potContent} />
    </div>
  );
};

export default Pot;
